import { gql } from '@apollo/client/core'
import { DRAFT_CUSTOM_AUDIENCE_ITEM } from './draftCustomAudienceItem'
import { DRAFT_STANDARD_AUDIENCE_ITEM } from './draftStandardAudienceItem'

// One memberItem selection: the backend keeps only the last of a repeated field, and a narrower selection
// would replace the cached member.
const AUDIENCE_QUESTION_LOGIC_MEMBER = gql`
  fragment AudienceQuestionLogicMember on DraftFieldworkAudienceMember {
    id
    number
    memberItem {
      __typename
      ... on DraftStandardAudienceItem {
        ...DraftStandardAudienceItem
        questionLogic {
          ...AudienceQuestionLogic
        }
      }
      ... on DraftCustomAudienceItem {
        ...DraftCustomAudienceItem
        questionLogic {
          ...AudienceQuestionLogic
        }
      }
    }
  }
  ${DRAFT_STANDARD_AUDIENCE_ITEM}
  ${DRAFT_CUSTOM_AUDIENCE_ITEM}
`

export default AUDIENCE_QUESTION_LOGIC_MEMBER
